import axios from "axios";

// Choose the backend URL at runtime.
// Rule: if the compiled REACT_APP_BACKEND_URL points to a host that differs
// from the domain we're actually being served from, prefer same-origin.
// This makes the frontend portable across deploy URLs (custom domains, etc.)
// without requiring a rebuild.
function resolveBackendUrl() {
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  const currentOrigin =
    typeof window !== "undefined" && window.location ? window.location.origin : "";

  const envLooksValid =
    typeof envUrl === "string" &&
    envUrl.length > 0 &&
    envUrl !== "undefined" &&
    /^https?:\/\//i.test(envUrl);

  if (!envLooksValid) return currentOrigin;
  if (!currentOrigin) return envUrl;

  try {
    const envHost = new URL(envUrl).host.toLowerCase();
    const curHost = new URL(currentOrigin).host.toLowerCase();
    if (envHost === curHost) return envUrl; // env matches; use it
    // Mismatch — the compiled env is stale relative to the domain we're
    // being served from. Same-origin is our best bet.
    return currentOrigin;
  } catch {
    return currentOrigin;
  }
}

const BACKEND_URL = resolveBackendUrl();
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ss_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Decorate network errors with the URL we tried, so toasts show something
// actionable instead of just "Network Error".
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err && !err.response && err.message === "Network Error") {
      err.message = `Network Error — could not reach ${API}`;
    }
    return Promise.reject(err);
  }
);
